import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2bf93cf2&scoped=true&"
import script from "@/lib/order/Form.js?vue&type=script&lang=js&"
export * from "@/lib/order/Form.js?vue&type=script&lang=js&"
import style0 from "@/lib/order/style/Form.css?vue&type=style&index=0&id=2bf93cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf93cf2",
  null
  
)

export default component.exports